<template>
	<div :class="['flex flex-col items-center']">
		<ConfettiExplosion
			:particle-count="500"
			:force="0.4"
			:duration="5000"
		/>

		<div class="won-modal-paragraph-color text-center text-2xl font-semibold">
			You’re now subscribed to the Premium tier!  Thanks for making us a part of your job search journey.
		</div>

		<div class="won-logo-text-color mt-5 text-base">
			A confirmation email should be on its way!
		</div>

		<won-subscription-success />
	</div>
</template>

<script setup>
import ConfettiExplosion from 'vue-confetti-explosion';
import WonSubscriptionSuccess from '../../../icons/won-subscription-success.vue';
</script>


